<template>
    <div class="page">


<div class="banner">
    <div class="banner-content">

        <form @submit.prevent>
            <h1>COMPÉTENCES</h1>
            <p>Durant mes deux premières années d'études j'ai eu l'occasion d'apprendre de nombreuses nouvelles
                compétences, retrouvez-les ci-dessous.</p>
            <label id="search-bar"><input class="mobile__recherche__btn" type="image"
                    src="https://www.u-pec.fr/images/loupe2.svg" alt="" aria-label="Lancer la recherche"><input
                     type="text" v-model="searchQuery"
                    placeholder="Rechercher une compétence ou un domaine" />
            </label>
        </form>
</div>
</div>



        <transition mode="out-in" name="fade">
            <div v-if="filteredCategories.length === 0" class="no-results">
                <h2>Aucun résultat trouvé pour "{{ searchQuery }}".</h2>
            </div>
        </transition>






        <transition-group mode="in-out" name="fade" tag="div" class="categories">
            <div v-for="category in filteredCategories" :key="category.domain" class="category">
                <h3 class="domain-title">{{ category.domain }}</h3>
                <div class="skill-collection">
                    <div :id="'skill-' + skill.id" v-for="skill in category.skills" :key="skill.id" class="skill">
                        <div class="top-part">
                            <div>
                                <h4 class="skill-title">{{ skill.title }}</h4><span class="span">{{ skill.place }}</span>
                            </div>
                            <img class="skill-image" :alt="'Icone ' +skill.title" :src="'/img/pictogramme/competences/' + skill.image">
                        </div>
                        <div class="bottom-part">
                            <p>{{ skill.description }}</p>
                           
                           
                             <div class="low-block">
                                <router-link
  v-if="skill.link && skill.link.length"
  :to="`/portfolio/tous/${normalizeName(randomLink(skill.link)) || 'not-found'}`"
>
  <button>Projet associé</button>
</router-link>
                                <span class="span">Level {{ skill.level }}<div class="level-indicator">
                                    <span v-for="n in 10" :key="n" class="circle" :class="{ active: n <= skill.level }">
                                    </span>
                             </div></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>





    </div>




</template>













<script>

export default {
    name: "Competencies",
    methods:{
        normalizeName(name) {
      if (typeof name !== 'string') return null;
      return name.toLowerCase().replace(/ /g, '-');
    },
    randomLink(links) {
      if (!Array.isArray(links) || links.length === 0) return null;
      const index = Math.floor(Math.random() * links.length);
      return links[index];
    }
},
    data() {
        return {
            searchQuery: "",
            categories: [
    {
        domain: "Langages informatique",
        skills: [
      { 
        id: 1, 
        title: "PHP", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'php.png', 
        description: "Langage backend utilisé principalement pour les projets de développement web, notamment dans le cadre de la SAE du semestre 2.", 
        level: "4", 
        link: ["Site Quantum","Site Eh Connard!"] 
      },
      { 
        id: 2, 
        title: "JavaScript", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'js.svg', 
        description: "Langage de script utilisé pour créer des interactions dynamiques sur mes sites web, surtout dans des projets personnels.", 
        level: "6",
        link: ["Shanks Website"]
      },
      { 
        id: 3, 
        title: "CSS", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'css.svg', 
        description: "Langage de style employé pour personnaliser l’apparence visuelle de mes sites web.", 
        level: "9" ,
        link: ["Site Eh Connard!"]
      },
      { 
        id: 4, 
        title: "HTML", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'html.svg', 
        description: "Langage de balisage utilisé pour structurer le contenu de mes pages web.", 
        level: "8",
        link: ["Site Quantum"]
      }
    ]
  },
  {
    domain: "Graphisme",
    skills: [
      { 
        id: 5, 
        title: "Adobe Photoshop", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'photoshop.png', 
        description: "Logiciel de retouche et de création graphique utilisé pour la conception d’affiches et la correction d’images.", 
        level: "8",
        link: ["Campagne Publicitaire"]
      },
      { 
        id: 6, 
        title: "Adobe Illustrator", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'illustrator.png', 
        description: "Logiciel vectoriel utilisé pour créer des logos, affiches et illustrations.", 
        level: "7",
        link: ["Limites planétaires"]
      }
    ]
  },
  {
    domain: "Audiovisuel",
    skills: [
      { 
        id: 7, 
        title: "Adobe After Effects", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'aftereffects.png', 
        description: "Logiciel de composition vidéo utilisé pour créer des animations et effets visuels avancés.", 
        level: "6",
        link: ["Scène d'épouvante"]
      },
      { 
        id: 8, 
        title: "Adobe Premiere Pro", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'premierepro.png', 
        description: "Logiciel de montage vidéo utilisé dans différents projets audiovisuels.", 
        level: "7",
        link: ["Scénario 360"]
      },
      { 
        id: 8, 
        title: "Synthesia", 
        place: 'Stage',  
        image: 'synthesia.png', 
        description: "Logiciel de montage vidéo utilisé dans différents projets audiovisuels.", 
        level: "9",
      },
      { 
        id: 9, 
        title: "Adobe Audition", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'audition.png', 
        description: "Logiciel de montage audio utilisé notamment pour le montage sonore d’interviews.", 
        level: "4",
        link: ["Eh Connard !"]
      },
      { 
        id: 10, 
        title: "Audacity", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'audacity.png', 
        description: "Logiciel pour le montage et l’amélioration de pistes audio.", 
        level: "3" 
      },
      { 
        id: 15, 
        title: "Sphere", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'sphere.png', 
        description: "Utilisé pour concevoir des expériences interactives en réalité virtuelle.", 
        level: "4" ,
        link: ["Expérience 360"]
      }
    ]
  },
  {
    domain: "3D",
    skills: [
      { 
        id: 11, 
        title: "Maya Autodesk", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'maya.webp', 
        description: "Logiciel de modélisation 3D utilisé pour créer des objets simples et s’initier à la 3D.", 
        level: "2" 
      }
    ]
  },
  {
    domain: "Framework",
    skills: [
      { 
        id: 12, 
        title: "Vue.js", 
        place: 'Projet personnel',  
        image: 'vuejs.ico', 
        description: "Framework JavaScript utilisé pour développer l’interface de mon portfolio.", 
        level: "6" 
      }
    ]
  },
  {
    domain: "CMS",
    skills: [
      { 
        id: 13, 
        title: "WordPress", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'wordpress.png', 
        description: "Plateforme de création de sites web sans code.", 
        level: "6",
        link: ["Site WordPress"]
      }
    ]
  },
  {
    domain: "Prototypage",
    skills: [
      { 
        id: 14, 
        title: "Axure RP", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'axure.png', 
        description: "Outil de prototypage interactif utilisé pour démontrer les principes d’accessibilité et d’ergonomie.", 
        level: "5",
        link: ["Marseille.fr"]
      },
      { 
        id: 15, 
        title: "Figma", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'figma.png', 
        description: "Logiciel de design UI/UX utilisé pour la création de maquettes de sites web.", 
        level: "4",
        link: ["Site Quantum"]
      },
      { 
        id: 16, 
        title: "FlutterFlow", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'flutterflow.png', 
        description: "Outil no-code utilisé pour concevoir des applications et jeux mobiles", 
        level: "5",
        link: ["Bat'H Game"]
      }
    ]
  },
  {
    domain: "Mise en page / Présentation",
    skills: [
      { 
        id: 17, 
        title: "Canva", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'canva.png', 
        description: "Logiciel graphique utilisé pour réaliser des présentations et supports visuels attrayants dans divers projets.", 
        level: "10",
        link: ["Sapik"]
      },
      { 
        id: 18, 
        title: "Word", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'word.png', 
        description: "Utilisé principalement pour la rédaction de rapports.", 
        level: "5" 
      },
      { 
        id: 19, 
        title: "PowerPoint", 
        place: 'Stage', 
        image: 'powerpoint.png', 
        description: "Utilisé pour créer des modules pédagogiques sur la cybersécurité via iSpring durant mon stage chez CyberSpector.", 
        level: "8" 
      },
      { 
        id: 20, 
        title: "Adobe InDesign", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'indesign.png', 
        description: "Logiciel de PAO utilisé pour des mises en page professionnelles de rapports écrits.", 
        level: "6" 
      },
      { 
        id: 21, 
        title: "Google Docs", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'gdoc.png', 
        description: "Outil collaboratif utilisé dans de nombreux projets pour rédiger nos scripts et idées en groupe de travail.", 
        level: "6",
        link: ["Quantum"]
      },
      { 
        id: 22, 
        title: "iSpring", 
        place: 'Stage',  
        image: 'iSpring.png', 
        description: "Extension de Power Point utilisé durant mon stage chez CyberSpector pour créer des modules de sensibilisations interactifs sur la cybersécurité.", 
        level: "9",
      }
    ]
  },
  {
    domain: "Animation",
    skills: [
      { 
        id: 22, 
        title: "Adobe Animate", 
        place: 'IUT Sénart-Fontainebleau',  
        image: 'animate.png', 
        description: "Logiciel utilisé pour créer des infographies animées, bandes dessinées et autres...", 
        level: "5",
        link: ["Bande-Dessinée"]
      }
    ]
  },
  {
    domain: "Déploiement de services",
    skills: [
      { 
        id: 23, 
        title: "Docker", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'docker.png', 
        description: "Outil de conteneurisation utilisé pour le déploiement rapide d’applications en local.", 
        level: "4",
        link: ["Site WordPress"]
      },
      { 
        id: 24, 
        title: "Wamp", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'wamp.png', 
        description: "Serveur local utilisé pour héberger les sites web en phase de développement.", 
        level: "5",
        link: ["Site Eh Connard!"]
      },
      { 
        id: 25, 
        title: "FileZilla", 
        place: 'IUT Sénart-Fontainebleau', 
        image: 'filezilla.png', 
        description: "Client FTP utilisé pour transférer et mettre en ligne mes sites web sur un serveur.", 
        level: "6",
        link: ["Site Quantum"]
      }
    ]
    }
]
        };
    },
    computed: {
        filteredCategories() {
            const searchQuery = this.searchQuery.toLowerCase();

            return this.categories
                .map(category => {
                    const matchesDomain = category.domain.toLowerCase().includes(searchQuery);
                    const filteredSkills = category.skills.filter(skill =>
                        skill.title.toLowerCase().includes(searchQuery)
                    );
                    
                    return matchesDomain
                        ? { ...category, skills: category.skills }
                        : { ...category, skills: filteredSkills };
                        
                })
                .filter(category => category.skills.length > 0);
        }
    }
}


</script>











<style scoped>

.banner {
    width: 100%;
    min-height: 50rem;
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),url(/public/img/banniere2.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 2rem;
    color: white;
    box-shadow: -5px 3px 15px rgba(0, 0, 0, 0.25);
}

button{
    padding:0.8rem 1.5rem;
}

.skill-image{
  width:3.75rem;
  height:3.75rem;
  object-fit: contain;
}

.banner-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 3rem 0;
    border-radius: 20px;
}

.banner-content p{
  padding:0 5rem;
}

.level-indicator {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-right: 10px;
    margin-top: 5px;
}

.circle {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    background-color: var(--gray-hover-1); /* Couleur pour les ronds inactifs */
    transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

.circle.active {
    background-color: var(--yellow-white); /* Couleur pour les ronds actifs */
}

form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2.5rem;
}

.page {
    min-height: 125vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.4) translateY(20px);
}

.fade-move {
  transition: transform 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
}

#search-bar {
    padding: 0.8rem;
    margin: 0 20px 20px 20px;
    border-radius: 7px 7px 0 0;
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    background: var(--yellow-white);
    border: 1px solid var(--gray);
    display: flex;
    align-items: center;
    justify-content: center;
}

#search-bar input[type="text"]{
    background: none;
    border: 0;
    outline: none;
    width:50rem;
}

form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2.5rem;
}


#search-bar input[type="image"]{
    width:2.5rem;
    filter: invert(1);
}

.no-results {
    text-align: center;
    margin: 20rem 0;
}

.domain-title {
    margin: 12px 0;
    padding-left: 15px;
    font-size: 25px !important;
}

.categories {
    display: flex;
    flex-direction: column;
    gap: 5rem;
    align-items: flex-start;
    margin: 5rem 0;
    flex-wrap: wrap;
    width: 100%;
    padding: 0 5vw;
}

.category{
    display: flex;
    flex-direction: column;
    width: 100%;
}

.skill-collection {
    display: flex;
    flex-wrap: wrap;
    gap: 2.5rem;
}

.top-part {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 15px;
    flex-wrap: wrap;
}

.skill-title {
    margin-bottom: 5px;
    transition: 0.2s cubic-bezier(0.23, 1, 0.320, 1);
}

.skill:hover .skill-title {
    text-decoration: underline;
}

.skill span {
    color: var(--gray);
}

.skill p {
    font-size: 1.33rem;
}

.skill {
    padding: 2rem;
    border-radius: 0;
    transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
    width: 30rem;
    background: var(--hard-blue);
    box-shadow: var(--box-shadow-1);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.bottom-part .low-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    flex-wrap: wrap;
    gap:4px;
}

@media(max-width:1385px){
    .skill h4{
      font-size:1.7rem !important;
    }
    .skill p{
      font-size:1.5rem !important;
    }
}

@media(max-width:1010px){
    .skill{
      width:42vw !important;
    }
    .skill p{
      font-size:1.5rem !important;
    }
}

@media(max-width:605px){
    .skill{
      width:100% !important;
    }
    .skill p{
      font-size:1.8rem !important;
    }
    .skill h4{
      font-size:2rem !important;
    }
    .domain-title{
      text-align: center;
    }

}

@media(max-width:490px){
    #search-bar input[type="text"]{
        width: 75vw;
    }
}

@media(max-width:525px){
    .skill-collection{
        justify-content: center;
    }
    .category{
        align-items: center;
    }
    .domain-title{
        padding-left: 0;
    }
}
</style>